import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`

export const CheckRow = styled(Row)`
  margin-bottom: 10px;
  flex-direction: row;
  align-items: center;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const ScheduleRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({index, service, professional}) => (
    index > 0
      ? service && professional
        ? '160px 2fr 120px 100px 50px'
        : '160px 2fr 50px 100px'
      : '160px 2fr 120px 100px'
  )};
  align-items: flex-start;
  justify-content: stretch;
  column-gap: 10px;
`

export const CalendarContainer = styled(Container)`
  padding: 0px;
  margin: 0px 30px 0px 0px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const DangerButton = styled(LookButton).attrs({ type: 'button' }).attrs(buttonLook({ variant: 'primary', destructive: true }))`
  height: 36px;
  align-self: flex-start;
  margin: 0px;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin-bottom: 4px;

  &:hover {
    cursor: pointer;
  }
`

export const InfoText = styled.p`
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  margin-top: 2px;
`

// Aviso que não bloqueia: cor de label em vez do vermelho de erro, com o ícone do Tooltip na frente
export const NoticeText = styled(InfoText)`
  display: flex;
  align-items: center;
  line-height: 16px;
  gap: 5px;
  color: #777777;
  text-align: left;
  margin-top: 3px;

  svg {
    flex-shrink: 0;
  }
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
  }
`
